import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import moment from 'moment';

import { HeaderLogo } from '../header/Header';

import { CustomLink } from 'src/components';

import { ROUTE } from 'src/constants';

import { CalendarIcon, LetterIcon, TelegramIcon } from 'src/assets';
import './footer.scss';

export const Footer = () => {
  const { t } = useTranslation('footer');

  const onClickLink = useCallback(() => {
    document.querySelector('body').scrollIntoView({ behavior: 'smooth' });
  }, []);

  return (
    <footer className="footer">
      <div className="footer__left">
        <HeaderLogo />
        <div className="footer__copyright">
          ©{moment().year()}
          {t('copyright')}
        </div>
      </div>
      <div className="footer__center">
        <div className="footer__navigation">
          <CustomLink title={t('exchange')} to={ROUTE.HOME} onClick={onClickLink} />
          <CustomLink
            to={ROUTE.EXCHANGE.DIRECTIONS}
            title={t('header:directions')}
            onClick={onClickLink}
          />
          <CustomLink to={ROUTE.REVIEWS} title={t('reviews')} onClick={onClickLink} />
          <CustomLink to={ROUTE.ABOUT_US} title={t('aboutUs')} onClick={onClickLink} />
          <CustomLink to={ROUTE.AGREEMENT} title={t('accept')} onClick={onClickLink} />
          <CustomLink to={ROUTE.CONTACTS} title={t('contacts')} onClick={onClickLink} />
        </div>
        <div className="footer__divider" />
        <div className="footer__workdays">
          <div className="footer__workdays__left">
            <img src={CalendarIcon} alt={CalendarIcon} />
            <span>{t('workTime')}</span> {t('workDays')}
          </div>
          <div className="footer__workdays__right">
            <Link to="mailto:support@exok.cash">
              <img src={LetterIcon} alt={LetterIcon} />
              E-mail
            </Link>
            <Link to="tg://resolve?domain=exok_manager" target="_blank">
              <img src={TelegramIcon} alt={TelegramIcon} />
              Telegram
            </Link>
            <Link to="tg://resolve?domain=ExOk_Exchange_bot" target="_blank">
              <img src={TelegramIcon} alt={TelegramIcon} />
              Telegram Bot
            </Link>
          </div>
        </div>
      </div>
      <div className="footer__description">{t('description')}</div>
    </footer>
  );
};
